import { jsx as e } from "react/jsx-runtime";
import { c as l } from "../../../index-Cu0xwYjD.js";
import '../../../assets/P.css';const m = "_body_a2c7v_5", r = "_sm_a2c7v_13", a = "_lg_a2c7v_17", d = "_xl_a2c7v_21", v = "_inverted_a2c7v_28", o = {
  body: m,
  sm: r,
  lg: a,
  xl: d,
  inverted: v
}, b = ({
  children: t,
  className: c,
  inverted: _,
  size: s = "md",
  ...n
}) => /* @__PURE__ */ e(
  "p",
  {
    className: l(
      o.body,
      {
        [o.inverted]: _
      },
      s == "md" ? null : {
        [o[s]]: s
      },
      c
    ),
    ...n,
    children: t
  }
);
export {
  b as P
};
